import { Component, computed, input } from '@angular/core';
import { ProjectDto } from '../../core/mceapi.client.generated';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'mce-project-header',
  imports: [MatDividerModule],
  templateUrl: './project-header.component.html',
  styleUrl: './project-header.component.scss'
})
export class ProjectHeaderComponent {

  project = input<ProjectDto>();

  protected readonly viewModel = computed(() => {
    return {

      showHeader: this.project() !== undefined,
      project: this.project() ?? {},

    };
  });

  protected get vm() { return this.viewModel(); }

}
